import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = { class: "text-large font-600 mr-3" }
const _hoisted_3 = { style: {"margin-top":"20px"} }

import { reactive, PropType, ref, unref, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';

/* Npm Plugins */
import { ElForm, FormRules, ElMessage } from 'element-plus';
import { Search } from '@element-plus/icons-vue';

/* 辅助 & hooks */
import { propTypes } from '@/utils/propTypes';
import { useAppStore } from '@/store/app';

import ContactList from './ContactList.vue';

/* Apis */
import { CpDetailApi, GetErpSupplierApi, GetErpCustomApi } from '../../../apis/counterpart/counterpart.api';

/* types */
import { CounterparCreate } from '@/apis/counterpart/counterpart.type';


export default /*#__PURE__*/_defineComponent({
  props: {
	titles: propTypes.string.def('数据展示/修改/编辑'),
	isPreview: propTypes.bool.def(false),
},
  setup(__props, { expose }) {

const props = __props

const { go } = useRouter();
const appStore = useAppStore();
const login = appStore.getLoginInfo as LoginInfo;

const loading = ref<boolean>(false);
const disInput = ref<boolean>(false);
const disEditor = ref<boolean>(false);
const canSelect = ref<boolean>(false);

const rules = reactive<FormRules>({
	no: [{ required: true, message: '相对方编号不能为空', trigger: 'blur' }],
	name: [{ required: true, message: '相对方名称不能为空', trigger: 'blur' }],
	part_type_id: [{ required: true, message: '纳税人资质不能留空', trigger: 'blur' }],
	pay_taxes: [{ required: true, message: '请选择相对方类型', trigger: 'blur' }],
	code: [{ required: true, message: '统一社会信用代码不能为空', trigger: 'blur' }],
	address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
});

const elFormRef = ref<ComponentRef<typeof ElForm>>();

const contactRef = ref<ComponentRef<typeof ContactList>>();

// const bankRef = ref<ComponentRef<typeof BankList>>()

const formSchema = ref<CounterparCreate>({
	curr_user_id: login.user_account,
	tenant_id: login.tenant_id,
	company_id: login.company_id,
	created_user_id: login.user_account,
	part_type_id: '',
	no: '',
	short_name: '',
	code: '',
	name: '',
	address: '',
	phone: '',
	contract: '',
	contract_num: '',
	country: '',
	province: '',
	pay_taxes: '',
	is_enabled: 'Y',
});



/* 获取明细数据 */
const getDetail = (rowId: string) => {
	loading.value = true;

	CpDetailApi(rowId)
		.then((res) => {
			if (!res.succeeded) {
				ElMessage.error(`读取相对方详细信息出错，可能的原因是：${res.errors}`);
			} else {
				const detail = res.data;

				formSchema.value = Object.assign({}, unref(formSchema), detail);

				/* 如果是供应商或者客户，某些数据不能修改 */
				if (detail.part_type_id == '2' || detail.part_type_id == '3') {
					disEditor.value = true;

					disInput.value = true;

					canSelect.value = true;
				}
			}
		})
		.finally(() => (loading.value = false));
};

/* 对外的属性与方法 */
const methods = {
	getFormData: () => {
		return formSchema?.value as CounterparCreate;
	},

	setData: (rowId: string) => {
		if (rowId) getDetail(rowId);
	},

	setAsyncData: (data: any) => {
		formSchema.value = Object.assign({}, unref(formSchema), data);
	},

	setLogin: (isLoad: boolean) => {
		loading.value = isLoad;
	},
};

/* 如果为：供应商或客户，则需要从接口上获取数据 */

const onPartTypeSelect = (val: string) => {
	disInput.value = val == '2' || val == '3' ? true : false;
};

/* 异步搜索 */
const searchLoading = ref<boolean>(false);
const customlist = ref<any[]>([]);

const remoteMethod = (val: string) => {
	if (val.length < 2) return;

	searchLoading.value = true;

	/* 供应商 */
	if (formSchema.value.part_type_id == '2') {
		GetErpSupplierApi(val)
			.then((res) => {
				customlist.value = res.data;
			})
			.finally(() => {
				searchLoading.value = false;
			});
	}

	/* 客户 */
	if (formSchema.value.part_type_id == '3') {
		GetErpCustomApi(val)
			.then((res) => {
				customlist.value = res.data;
			})
			.finally(() => {
				searchLoading.value = false;
			});
	}
};

/* 选中值 */
const onSelectChange = (item: any) => {
	if (formSchema.value.part_type_id == '2') {
		unref(formSchema).no = item.venno;
		unref(formSchema).name = item.vensname;
		unref(formSchema).short_name = item.shortname;
		unref(formSchema).address = item.cadd;
		unref(formSchema).code = item.business_license;

		unref(formSchema).contract = item.leal_person;
		unref(formSchema).contract_num = item.mobil;

		unref(formSchema).invoice_title = item.invoice_name;
		unref(formSchema).invoice_address = item.invoice_address;
	}

	/* 客户 */
	if (formSchema.value.part_type_id == '3') {
		unref(formSchema).no = item.custno;
		unref(formSchema).name = item.custsname;
		unref(formSchema).short_name = item.shortname;
		unref(formSchema).code = item.business_license;

		unref(formSchema).contract = item.leal_person;
		unref(formSchema).contract_num = item.tel;

		unref(formSchema).invoice_title = item.invoice_name;
		unref(formSchema).invoice_address = item.invoice_address;
	}
};

expose({ elFormRef, contactRef, methods });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          onBack: _cache[18] || (_cache[18] = ($event: any) => (_unref(go)(-1)))
        }, {
          content: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.titles), 1)
          ]),
          extra: _withCtx(() => [
            _renderSlot(_ctx.$slots, "Options")
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_tabs, { type: "border-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "基础资料",
                    disabled: loading.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElForm), {
                        ref_key: "elFormRef",
                        ref: elFormRef,
                        model: formSchema.value,
                        "label-width": "120px",
                        "label-position": 'top',
                        rules: _unref(rules),
                        disabled: props.isPreview,
                        style: {"padding":"20px 40px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "类型",
                                    prop: "part_type_id"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        style: {"width":"100%"},
                                        modelValue: formSchema.value.part_type_id,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.part_type_id) = $event)),
                                        disabled: disEditor.value,
                                        placeholder: "请选择相对方类型",
                                        onChange: onPartTypeSelect
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "内部单位",
                                            value: "1"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "供应商",
                                            value: "2"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "客户",
                                            value: "3"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "合作伙伴",
                                            value: "4"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "其他",
                                            value: "99"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "名称",
                                    prop: "name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.name,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.name) = $event)),
                                        disabled: disInput.value,
                                        placeholder: "请输入相对方名称"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "简称",
                                    prop: "short_name"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.short_name,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.short_name) = $event)),
                                        disabled: disInput.value,
                                        placeholder: "请输入相对方简称"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  (formSchema.value.part_type_id == '2' || formSchema.value.part_type_id == '3')
                                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 0,
                                        label: "编号",
                                        prop: "no"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            style: {"width":"100%"},
                                            modelValue: formSchema.value.no,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.no) = $event)),
                                            filterable: "",
                                            remote: "",
                                            disabled: canSelect.value,
                                            "reserve-keyword": "",
                                            "remote-show-suffix": "",
                                            loading: searchLoading.value,
                                            placeholder: "请输入名称或编号进行搜索，需要2个(含)字符以上",
                                            "remote-method": remoteMethod,
                                            onChange: onSelectChange
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customlist.value, (item, idx) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: idx,
                                                  label: item.vensname || item.custsname,
                                                  value: item
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "disabled", "loading"])
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_el_form_item, {
                                        key: 1,
                                        label: "编号",
                                        prop: "no"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: formSchema.value.no,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.no) = $event)),
                                            placeholder: "请输入相对方编号"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "手机/固话",
                                    prop: "phone"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.phone,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.phone) = $event)),
                                        placeholder: "请输入手机/固话"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "法人姓名",
                                    prop: "contract"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.contract,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.contract) = $event)),
                                        placeholder: "请输入联系人"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "法人联系方式",
                                    prop: "contract_num"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.contract_num,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.contract_num) = $event)),
                                        placeholder: "请输入联系人电话"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "统一社会信用代码",
                                    prop: "code"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.code,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.code) = $event)),
                                        disabled: disInput.value,
                                        placeholder: "请输入统一社会信用代码"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "国家",
                                    prop: "country"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.country,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.country) = $event)),
                                        placeholder: "请输入国籍"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "省份/州",
                                    prop: "country"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.province,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.province) = $event)),
                                        placeholder: "请输入地区"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "地址",
                                    prop: "address"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.address,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.address) = $event)),
                                        placeholder: "请输入地址"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { label: "纳税人资质" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: formSchema.value.pay_taxes,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formSchema.value.pay_taxes) = $event)),
                                        style: {"width":"100%"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "增值税一般纳税人",
                                            value: "1"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { label: "发票抬头" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.invoice_title,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formSchema.value.invoice_title) = $event)),
                                        placeholder: "请录入发票抬头"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { label: "开票地址" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: formSchema.value.invoice_address,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formSchema.value.invoice_address) = $event)),
                                        placeholder: "请录入开票地址"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { label: "经营范围" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "textarea",
                                        modelValue: formSchema.value.business_scope,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formSchema.value.business_scope) = $event)),
                                        rows: "2",
                                        "show-word-limit": "",
                                        maxlength: "1000"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, { label: "备注" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        type: "textarea",
                                        modelValue: formSchema.value.remark,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formSchema.value.remark) = $event)),
                                        rows: "2",
                                        "show-word-limit": "",
                                        maxlength: "150"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { gutter: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    label: "启用/停用",
                                    prop: "is_enabled"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        style: {"width":"100%"},
                                        modelValue: formSchema.value.is_enabled,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "启用",
                                            value: "Y"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "停用",
                                            value: "N"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_tab_pane, { label: "联系人" }, {
                    default: _withCtx(() => [
                      _createVNode(ContactList, {
                        ref_key: "contactRef",
                        ref: contactRef,
                        "cp-id": formSchema.value.id || '',
                        privew: props.isPreview
                      }, null, 8, ["cp-id", "privew"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, { label: "银行信息" })
                ]),
                _: 1
              })
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    })
  ])), [
    [_directive_loading, loading.value]
  ])
}
}

})